import { Dispatch } from "redux";
import { Schedule } from "typings";

const SET_SESSION = "SET_SESSION";
const SESSION_LOADING = "SESSION_LOADING";

export interface Session {
  isLoading: boolean;
  isLoggedIn: boolean;
  id: number;
  company: string;
  email: string;
  firstName: string;
  lastName: string;
  organizationId: string;
  organizationRole: string;
  jwtToken: string;
  name: string;
}

export const setSessionLoading = (isLoading: boolean) => ({
  type: SESSION_LOADING,
  payload: isLoading,
});

// TODO: Update user type and payload based on API v2
export const loadSession = (user: {
  id: number;
  name: string;
  first_name: string;
  last_name: string;
  pacer_username: string;
  company: string;
  email: string;
  schedules: Schedule[];
  organization_id: number;
  organization_role: string;
  ecf_email: string;
  enable_desktop_notifications: boolean;
  jwt_token: string;
  pubsub_key: string;
}) => (dispatch: Dispatch) => {
  const {
    id,
    first_name: firstName,
    last_name: lastName,
    company,
    email,
    name,
    organization_id,
    organization_role,
    jwt_token,
  } = user;
  dispatch({
    type: SET_SESSION,
    payload: {
      id,
      name,
      firstName,
      lastName,
      company,
      email,
      organizationId: organization_id,
      organizationRole: organization_role,
      jwtToken: jwt_token,
      isloggedin: true,
    },
  });
};

export type SessionAction =
  | { type: typeof SET_SESSION; payload: Session }
  | {
      type: typeof SESSION_LOADING;
      payload: boolean;
    };

const initialState: Session = {
  isLoading: false,
  isLoggedIn: false,
  id: 0,
  name: " John Doe",
  firstName: "John",
  lastName: "Doe",
  organizationId: "",
  organizationRole: "",
  jwtToken: "",
  company: "",
  email: "",
};

export default (state = initialState, action: SessionAction) => {
  switch (action.type) {
    case SET_SESSION: {
      const {
        name = "",
        firstName = "",
        lastName = "",
        company = "",
        email = "",
        id = 1,
        organizationId,
        organizationRole,
        jwtToken,
      } = action.payload;
      return {
        ...state,
        isLoggedIn: action.payload.isLoggedIn,
        name,
        firstName,
        lastName,
        company,
        email,
        id,
        organizationId,
        organizationRole,
        jwtToken,
      };
    }
    case SESSION_LOADING: {
      return {
        ...state,
        isLoading: action.payload,
      };
    }
    default:
      return state;
  }
};
